"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var invariant = require("invariant");
var compose_1 = require("./compose");
var types = require("./type");
var required_1 = require("./exist/required");
var utils_1 = require("./helper/utils");
var getType_1 = require("./helper/getType");
/**
 * @todo
 * support javascript native types: Map, Set, Buffer
 * Global error message.
 */
var compose_2 = require("./compose");
exports.compose = compose_2.default;
var noop = function () { return new Promise(function (resolve) { return resolve({}); }); };
function getValidator(fieldSchmea, fieldMessages, field) {
    var _this = this;
    var type = fieldSchmea.type, required = fieldSchmea.required, rest = __rest(fieldSchmea, ["type", "required"]);
    var fieldType = type;
    var rules = [];
    if (!fieldType) {
        fieldType = fieldSchmea;
    }
    else {
        // adaptation API into inner logic which return false mean validation correct, and return string
        // mean validation error.
        rules = Object.keys(rest).map(function (ruleKey) {
            var fieldMsgProducer = (fieldMessages[ruleKey] || '');
            // tslint:disable-next-line:no-any
            return function (value) { return __awaiter(_this, void 0, void 0, function () {
                var fieldMsg;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (utils_1.isFuntion(fieldMsgProducer)) {
                                // we make fieldMsgProducer is executable by isFunction.
                                fieldMsg = fieldMsgProducer(value) || '';
                            }
                            else if (utils_1.isString(fieldMsgProducer)) {
                                fieldMsg = fieldMsgProducer;
                            }
                            else {
                                invariant(false, 'Kya: message field should be either Function or String');
                            }
                            return [4 /*yield*/, rest[ruleKey](value)];
                        case 1: return [2 /*return*/, (_a.sent()) ? false : { message: fieldMsg }];
                    }
                });
            }); };
        });
    }
    var _a = getType_1.default(fieldType), typeName = _a[0], typeOptions = _a[1];
    var composed = compose_1.default.apply(void 0, [types[typeName].type(fieldMessages.type, typeOptions)].concat(rules));
    if (required) {
        return required_1.default(composed, fieldMessages.required);
    }
    return composed;
}
function kya(schema, messages) {
    if (schema === void 0) { schema = {}; }
    if (messages === void 0) { messages = {}; }
    function validate(target) {
        if (target === void 0) { target = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var fields, results;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fields = Object.keys(schema);
                        return [4 /*yield*/, fields.reduce(function (accuP, field) { return __awaiter(_this, void 0, void 0, function () {
                                var _a, schemaObj, messagesObj, validator, result, accuResult;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            schemaObj = schema[field];
                                            messagesObj = messages[field] || {};
                                            if (!schemaObj) {
                                                return [2 /*return*/, accuP];
                                            }
                                            validator = getValidator(schemaObj, messagesObj, field);
                                            return [4 /*yield*/, validator(target[field])];
                                        case 1:
                                            result = _b.sent();
                                            return [4 /*yield*/, accuP];
                                        case 2:
                                            accuResult = _b.sent();
                                            return [2 /*return*/, Promise.resolve(__assign({}, accuResult, (_a = {}, _a[field] = result, _a)))];
                                    }
                                });
                            }); }, noop())];
                    case 1:
                        results = _a.sent();
                        return [2 /*return*/, results];
                }
            });
        });
    }
    function validateOn(target) {
        if (target === void 0) { target = {}; }
        var onfields = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            onfields[_i - 1] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var results;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, onfields.reduce(function (accuP, field) { return __awaiter(_this, void 0, void 0, function () {
                            var schemaObj, messagesObj, validator;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        schemaObj = schema[field];
                                        messagesObj = messages[field] || {};
                                        if (!schemaObj) {
                                            return [2 /*return*/, accuP];
                                        }
                                        validator = getValidator(schemaObj, messagesObj, field);
                                        return [4 /*yield*/, validator(target[field])
                                                // tslint:disable-next-line:no-any
                                                .then(function (result) {
                                                accuP.then(function (accu) {
                                                    accu[field] = result;
                                                });
                                            })];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/, accuP];
                                }
                            });
                        }); }, noop())];
                    case 1:
                        results = _a.sent();
                        return [2 /*return*/, results];
                }
            });
        });
    }
    return {
        validate: validate,
        validateOn: validateOn,
    };
}
exports.default = kya;



//////////////////
// WEBPACK FOOTER
// ../node_modules/kya/dist/kya.js
// module id = 316
// module chunks = 0